import { render, staticRenderFns } from "./MarketingPrompt.vue?vue&type=template&id=0f7242ca&scoped=true&"
import script from "./MarketingPrompt.vue?vue&type=script&lang=js&"
export * from "./MarketingPrompt.vue?vue&type=script&lang=js&"
import style0 from "./MarketingPrompt.vue?vue&type=style&index=0&id=0f7242ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7242ca",
  null
  
)

export default component.exports